
import ReactPlayer from "components/react-player/src/index";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";
import { Image, View } from "react-native";
import { useRef } from "react";
import VText from "components/VText";
import { StyleSheet } from "react-native";
import { Images } from "assets";
import { TouchableOpacity } from "react-native";
import { useState } from "react";
import Heading from "components/Heading";

const styles = StyleSheet.create({
    title: {
        alignSelf: "center",
        marginTop: spV(32),
        fontFamily: "LibreBodoni",
        fontSize: fp(28),
        fontWeight: "300",
    },
    heading: {
        fontFamily: "LibreBodoni",
        fontSize: fp(23),
        fontWeight: "500",
        marginBottom: spV(8),
    },
    description: {
        width: wp(270),
        fontSize: fp(16),
        fontWeight: "300",
    },
});


const GuestView = () => {
    const _videoRef = useRef();

    const [isVideoPlaying, setIsVideoPlaying] = useState(false);


    return (
        <View style={{ alignItems: "center" }}>
        <Heading type="h1" style={styles.title}>AI Stylist Search</Heading>
        <View onTouchStart={() => setIsVideoPlaying(true)} style={{ justifyContent: "center", alignItems: "center", position: "relative", width: wp(1000), height: hp(563), marginTop: spV(20) }} >
            <TouchableOpacity onPress={() => setIsVideoPlaying(true)}>
            <ReactPlayer
                ref={_videoRef}
                width={wp(1000)}
                height={hp(563)}
                style={{ marginTop: spV(20),backgroundColor:"black" }}
                light={"https://vetirstylistadminassets.s3.amazonaws.com/1733401424118.png"}
                controls={true}
                playing={true}
                url="https://vetirapp-images.s3.us-east-1.amazonaws.com/AI+Stylist+Web-Updated.mp4"
            />

            </TouchableOpacity>
        </View>
        <View style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", marginVertical: spV(20), gap: spH(20) }}>
            <Image accessibilityLabel="AI Stylist QR Code" source={Images.aiStylistDeeplinkQR} style={{ width: wp(100), height: hp(100) }} />
            <View>
                <VText style={styles.heading}>Ask me Anything</VText>
                <VText style={styles.description}>Login for unlimited access to the Vêtir AI Stylist.
                Scan the QR code to Download the Vêtir app on your iOS.</VText>
            </View>
        </View>
    </View>
    );
};

export default GuestView;